import { UIFlightData } from "@flights/types";
import { carrierUtils, isFeatureRunningClientSide } from "@flights/web-api-utils-universal";

export const shouldPreopenBrandedFares = (flight: UIFlightData) =>
  isFeatureRunningClientSide("FLIGHTS_PRE_OPEN_BRANDED_FARES_DELTA") &&
  carrierUtils.hasAnyCarrier(flight.segments, "DL");
